import React from "react";
import propTypes from "prop-types";
import { SelectInput } from "../../../global/components/forms";


const SelectOrganizationInput = ({
  organizations = []
  , selectedOrganizationId = ''
  , change = () => console.warn('SelectOrganizationInput change function not provided')
}) => {
  return (
    <SelectInput
      name='organizationId'
      className='flex-1 !z-50 max-w-[200px]'
      bgClass='bg-neutral-pri'
      textClass='text-neutral-pri'
      selectedValue={selectedOrganizationId || ''}
      change={change}
      items={organizations}
      displayKey={'name'}
      valueKey={'_id'}
      placeholder={'Select Organization'}
    />
  )

};

SelectOrganizationInput.propTypes = {
  organizations: propTypes.array,
  selectedOrganizationId: propTypes.string,
  change: propTypes.func.isRequired,
};

export default SelectOrganizationInput;